import jQuery from 'jquery';

jQuery('.main-opinions-slider').slick({
  fade: true,
  dots: true,
  arrows: false
});
